export const apiName = 'GetEcsFeatureFlags';
